import {
  InferType,
  array,
  number,
  object,
  string,
} from '@/validations/custom-yup';

export const tableSchema = object({
  page: number(),
  size: number(),
  sort: array().of(string().required()),
});

export type TableSchema = InferType<typeof tableSchema>;
